module.exports = {
    HOST: "http://localhost:3000",
    REGION: "ap-northeast-2",
    ACCESS_KEY_ID: "AKIAQM6MZMWV6NZM5N7T",
    SECRET_ACCESS_KEY: "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",
    KAKAO_APP_KEY: "ff32e22bed5946362a8f5a6f12a88b7b"
}
